export default __webpack_public_path__ + "static/media/performance.29a6f62f.png";